import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import AddIcon from "@mui/icons-material/Add";
import {
  Autocomplete,
  ButtonGroup,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  ListItem,
  ListItemText,
  Stack,
  TextField,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { FieldArray, Form, Formik, getIn, useFormikContext } from "formik";
import * as Yup from "yup";
import { Close } from "@mui/icons-material";
import { useCreateItemsMutation, useGetAllItemsQuery, useGetPartnerZonesQuery, usePartnersQuery } from "../../Slices/roomNateApis";
import { ErrorAlert, SuccessAlert } from "../../utils/Alerts";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
import { useGlobalAuthContext } from "../../context/AuthContext";
import { baseUrl } from "../../utils/baseUrl";
import { useGlobalContext } from "../../context/GlobalContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  height: "90%",
  overflowY: "auto",
  width: { xs: "90%", md: "650px" },
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function BasicModal({
  zonesData: zonesAPIData,
  connectionPointsData,
  connectionPointsOptionsData,
  defaultType = 1,
}) {

  const { currentUserSessionStorage } = useGlobalAuthContext();
  const { activePartner } = useGlobalContext()
  
  const [formValue, setFormValue] = React.useState(null)


  
  const FormikWatcher = ({ onValuesChange }) => {
    const { values } = useFormikContext();
  
    React.useEffect(() => {
      onValuesChange(values);
    }, [values, onValuesChange]);
  
    return null;
  };

    const {
      data: FetchItems,
    } = useGetAllItemsQuery({ itemType: 1, activePartner: formValue?.partners });
  
  const formRef = React.useRef();
  const fieldRefs = React.useRef({}); 

  const [frontImage, setFrontImage] = React.useState("");
  const [topImage, setTopImage] = React.useState("");
  const [createItem, resultStats] = useCreateItemsMutation();
  const [open, setOpen] = React.useState(false);
  const [load, setLoad] = React.useState(false);
  const [successAlert, setSuccessAlert] = React.useState(false);
  const [errorAlert, setErrorAlert] = React.useState(false);

  const {data: partnersData } = usePartnersQuery();
  

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;



  const { data: partnerZones , error } = useGetPartnerZonesQuery(formValue?.partners, {
    skip: !Array.isArray(formValue?.partners),
  })
  
    
  const zonesData = error?.status ? zonesAPIData: partnerZones && partnerZones?.length >= 1 ? partnerZones.filter((zone) => zone?.value != "custom") : zonesAPIData;

  const validationSchema = Yup.object().shape({
    frontViewImage: Yup.mixed().required("File is required"),
    topViewImage: Yup.mixed().required("File is required"),
    name: Yup.string().required("No name provided"),
    zoneValue: Yup.array().min(1, "Atleast Select one"),
    type: Yup.number()
      .typeError("You haven't selected yet")
      .required("You must have to select one thing"),
    variants: Yup.array().of(
      Yup.object().shape({
        priority: Yup.number().required("Priority is required"),
        name: Yup.string().required("Name is required"),
        length: Yup.number()
          .required("Length is required")
          .positive("Length must be positive"),
        width: Yup.number()
          .required("Width is required")
          .positive("Width must be positive"),
      })
    ),
  });

  React.useEffect(() => {
    if (resultStats?.isLoading) {
      setLoad(true);
    }

    if (!resultStats?.isLoading) {
      setLoad(false);
    }

    if (resultStats?.isSuccess) {
      setSuccessAlert(true);
      setFrontImage("");
      setTopImage("");
      setTimeout(() => {
        setSuccessAlert(false);
      }, 2000);
      handleClose();
    }

    if (resultStats?.isError) {
      setErrorAlert(true);
      setTimeout(() => {
        setErrorAlert(false);
      }, 2000);
    }
  }, [resultStats]);

  React.useEffect(() => {
    if (frontImage !== "") {
      if (frontImage.size >= 1e7) {
        setFrontImage("");
      } else {
        const fd = new FormData();
        fd.append("image", frontImage);
        axios
          .post("/items/image-upload/", fd, {
            headers: {
              Authorization: `Bearer ${currentUserSessionStorage}`,
            },
          })
          .then((resp) => {
            formRef?.current?.setValues({
              ...formRef?.current?.values,
              frontViewImage: resp?.data?.path,
            });
          });
      }
    }
  }, [frontImage, currentUserSessionStorage]);

  React.useEffect(() => {
    if (topImage !== "") {
      if (topImage.size >= 1e7) {
        setTopImage("");
      } else {
        const fd = new FormData();
        fd.append("image", topImage);
        axios
          .post("/items/image-upload/", fd, {
            headers: {
              Authorization: `Bearer ${currentUserSessionStorage}`,
            },
          })
          .then((resp) => {
            formRef?.current?.setValues({
              ...formRef?.current?.values,
              topViewImage: resp?.data?.path,
            });
          });
      }
    }
  }, [topImage, currentUserSessionStorage]);

  const updateQty = (itemId, qty) => {
    const updatedItems = formRef?.current?.values.items.map((item) => {
      if (item._id === itemId) {
        return {
          ...item,
          qty,
          capacity: qty,
        };
      } else {
        return item;
      }
    });

    formRef?.current?.setValues((prevValues) => ({
      ...prevValues,
      items: updatedItems,
    }));
  };

  const handleInc = (itemId) => {
    const item = formRef?.current?.values.items.find(
      (item) => item._id === itemId
    );
    if (item) {
      const newQty = item.qty + 1;
      updateQty(itemId, newQty);
    }
  };

  const handleDec = (itemId) => {
    const item = formRef?.current?.values.items.find(
      (item) => item._id === itemId
    );
    if (item && item.qty > 1) {
      const newQty = item.qty - 1;
      updateQty(itemId, newQty);
    }
  };
  const scrollToError = (errors) => {
    const firstErrorKey = Object.keys(errors)[0]; 

    if (firstErrorKey !== "variants") {
      if (fieldRefs.current[firstErrorKey]) {
        fieldRefs.current[firstErrorKey].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    } else {
      const firstVariantIndex = Object.keys(errors.variants)[0]; 

      if (firstVariantIndex !== undefined) {
        const firstFieldKey = Object.keys(
          errors.variants[firstVariantIndex]
        )[0]; 
        const refKey = `variants.[${firstVariantIndex}].${firstFieldKey}`;

        if (fieldRefs.current[refKey]) {
          fieldRefs.current[refKey].scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }
    }
  };

  return (
    <>
      {successAlert && (
        <SuccessAlert title="Item has been created successfully!" />
      )}

      {errorAlert && <ErrorAlert title="Something Went Wrong!" />}

      <Button onClick={handleOpen} variant="outlined" endIcon={<AddIcon />}>
        {defaultType === 2 ? "Add Layout" : "Add Item"}
      </Button>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box position="fixed" top={10} right={0}>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Box>
          <Formik
            innerRef={formRef}
            initialValues={{
              showCustomVariants: false,
              includeSelection: false,
              variants: [
                {
                  name: "",
                  priority: 10,
                  length: "",
                  width: "",
                  capacity: "",
                  spacing: {
                    north: "",
                    east: "",
                    west: "",
                    south: "",
                  },
                },
              ],
              type: defaultType,
              clearanceItems: [],
              likelihood: 10,
              frontViewImage: "",
              topViewImage: "",
              name: "",
              zoneValue: [],
              shapeValue: [],
              aboutItem: "",
              items: [],
              circularPoints: {
                north: 7,
                south: 7,
                east: 7,
                west: 7,
                northwest: 7,
                northeast: 7,
                southeast: 7,
                southwest: 7,
                center: 7,
                top: 7,
                bottom: 7,
                cce: 7,
                ccw: 7,
              },
              wallAttachments: {
                north: 7,
                south: 7,
                east: 7,
                west: 7,
                northwest: 7,
                northeast: 7,
                southeast: 7,
                southwest: 7,
                center: 7,
                top: 7,
                bottom: 7,
                cce: 7,
                ccw: 7,
              },
              floorAttachments: {
                north: 7,
                south: 7,
                east: 7,
                west: 7,
                northwest: 7,
                northeast: 7,
                southeast: 7,
                southwest: 7,
                center: 7,
                top: 7,
                bottom: 7,
                cce: 7,
                ccw: 7,
              },
              subdomains: [],
              partners: activePartner ? [activePartner] : []
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(false);
              let data;
              const {
                frontViewImage,
                topViewImage,
                name,
                zoneValue,
                variants,
                shapeValue,
                circularPoints,
                wallAttachments,
                floorAttachments,
                type,
                likelihood,
                items,
                clearanceItems,
                showCustomVariants,
                includeSelection,
                partners
              } = values;

              let zones = zoneValue.map((item, _) => item.value);
              let shapes = shapeValue.map((item, _) => item.value);

              const newClearanceItems = clearanceItems.map((item) => ({
                name: item.name,
                _id: item._id,
              }));

              const layoutItemsChange = items.map(({ _id, capacity }) => ({
                _id,
                capacity: capacity || 1,
              }));

              if (type == 2) {
                data = {
                  zones,
                  frontViewImage,
                  topViewImage,
                  name,
                  variants,
                  shapes,
                  circularPoints,
                  wallAttachments,
                  floorAttachments,
                  type,
                  likelihood: likelihood || 10,
                  layoutItems: layoutItemsChange,
                  clearanceItems: newClearanceItems,
                  showCustomVariants,
                  includeSelection,
                  partners
                };
              }

              if (type == 1) {
                data = {
                  zones,
                  frontViewImage,
                  topViewImage,
                  name,
                  variants,
                  shapes,
                  circularPoints,
                  wallAttachments,
                  floorAttachments,
                  type,
                  likelihood: likelihood || 10,
                  clearanceItems: newClearanceItems,
                  showCustomVariants,
                  includeSelection,
                  partners


                  
                };
              }

              createItem(data);
            }}
          >
            {({
              values,
              touched,
              errors,
              handleChange,
              handleBlur,
              setValues,
              validateForm,
            }) => (
              <Form noValidate autoComplete="off">
                <FormikWatcher onValuesChange={(vals) => setFormValue(vals)} />


                <Typography
                  id="modal-modal-title"
                  fontWeight={"bold"}
                  fontSize={"20px"}
                  variant="h6"
                  mb={2}
                >
                  {defaultType === 2 ? "Create a Layout" : "Create a Item"}
                </Typography>

                <Stack justifyContent={"space-between"} flexDirection="row">
                  <Stack
                    flexDirection={"column-reverse"}
                    ref={(el) => (fieldRefs.current["frontViewImage"] = el)}
                  >
                    {Boolean(
                      getIn(touched, "frontViewImage") &&
                        getIn(errors, "frontViewImage")
                    ) && (
                      <span className="error">{errors?.frontViewImage}</span>
                    )}

                    <Button variant="contained" component="label">
                      Upload
                      <input
                        hidden
                        accept="image/*"
                        name="frontViewImage"
                        type="file"
                        onChange={(e) => setFrontImage(e.target.files[0])}
                      />
                    </Button>

                    <Box>
                      <img
                        src={
                          frontImage
                            ? URL.createObjectURL(frontImage)
                            : "https://placehold.jp/90x90.png"
                        }
                        alt={
                          values?.frontViewImage
                            ? values?.frontViewImage
                            : "placeHolder"
                        }
                        height="100px"
                      />
                    </Box>
                    <Typography fontWeight={"bold"} mb={1}>
                      Front View
                    </Typography>
                  </Stack>

                  <Stack
                    flexDirection={"column-reverse"}
                    ref={(el) => (fieldRefs.current["topViewImage"] = el)}
                  >
                    {Boolean(
                      getIn(touched, "topViewImage") &&
                        getIn(errors, "topViewImage")
                    ) && <span className="error">{errors?.topViewImage}</span>}

                    <Button variant="contained" component="label">
                      Upload
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        name="topViewImage"
                        onChange={(e) => setTopImage(e.target.files[0])}
                      />
                    </Button>
                    {
                      <Box>
                        <img
                          src={
                            topImage
                              ? URL.createObjectURL(topImage)
                              : "https://placehold.jp/90x90.png"
                          }
                          alt={
                            values?.topViewImage
                              ? values?.topViewImage
                              : "placeHolder"
                          }
                          height="100px"
                        />
                      </Box>
                    }
                    <Typography fontWeight={"bold"} mb={1}>
                      Top View
                    </Typography>
                  </Stack>
                </Stack>

                {aboutItem && (
                  <Stack mt={2}>
                    <Autocomplete
                      disablePortal
                      onChange={(_, value) =>
                        setValues({
                          ...values,
                          type: (value || value === "") && value.value,
                          items: (value || value === "") && [],
                        })
                      }
                      name="type"
                      id="combo-box-demo"
                      options={aboutItem}
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => (
                        <TextField
                          placeholder="Select if is item or layout"
                          name="type"
                          {...params}
                          label="About Item"
                          onBlur={handleBlur}
                          helperText={
                            getIn(touched, "type") && getIn(errors, "type")
                              ? getIn(errors, "type")
                              : ""
                          }
                          error={Boolean(
                            getIn(touched, "type") && getIn(errors, "type")
                          )}
                        />
                      )}
                    />
                  </Stack>
                )}

                <Stack mt={2}>
                  <FormControlLabel
                    name="includeSelection"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    ref={(el) => (fieldRefs.current["includeSelection"] = el)}
                    value={values.includeSelection}
                    required
                    control={<Checkbox />}
                    label="Show item on selection to user"
                  />
                </Stack>

                <Stack>
                  <FormControlLabel
                    name="showCustomVariants"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    ref={(el) => (fieldRefs.current["showCustomVariants"] = el)}
                    value={values.showCustomVariants}
                    required
                    control={<Checkbox />}
                    label="Show custom options of variants"
                  />
                </Stack>


                <Stack mt={2}>
                <Autocomplete
                  onChange={(_, value) => {
                    const uniqueValues = Array?.from(new Set(value?.map((partner) => partner?.value)));
                    setValues({ ...values, partners: uniqueValues });
                  }}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  required
                  name="partners"
                  multiple
                  id="checkboxes-tags-partners"
                  options={partnersData?.map((partner) => ({ label: partner?.title, value: partner?._id }))}
                  value={values?.partners?.map(id => {
                    const item = partnersData?.find(obj => obj._id === id);
                    return item ? { label: item.title, value: item._id } : null;
                  }).filter(item => item !== null) || []}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.label}
                  renderOption={(props, option, { selected }) => (
                    
                    <li {...props} key={option._id}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.label}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="partners"
                      label="Partner"
                      ref={(el) => (fieldRefs.current["partners"] = el)}
                      placeholder="Partner"
                      onBlur={handleBlur}
                      helperText={
                        getIn(touched, "partners") &&
                        getIn(errors, "partners")
                          ? getIn(errors, "partners")
                          : ""
                      }
                      error={Boolean(
                        getIn(touched, "partners") &&
                        getIn(errors, "partners")
                      )}
                    />
                  )}
                />
              </Stack>

                <Stack my={2}>
                  <TextField
                    id="outlined-basic"
                    label="Name"
                    variants="outlined"
                    name="name"
                    fullWidth
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                    required
                    ref={(el) => (fieldRefs.current["name"] = el)}
                    helperText={
                      getIn(touched, "name") && getIn(errors, "name")
                        ? getIn(errors, "name")
                        : ""
                    }
                    error={Boolean(
                      getIn(touched, "name") && getIn(errors, "name")
                    )}
                  />
                </Stack>

                <Stack my={2}>
                  <TextField
                    id="outlined-basic"
                    label="Likelihood"
                    variants="outlined"
                    name="likelihood"
                    fullWidth
                    ref={(el) => (fieldRefs.current["likelihood"] = el)}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.likelihood}
                    required
                    helperText={
                      getIn(touched, "likelihood") &&
                      getIn(errors, "likelihood")
                        ? getIn(errors, "likelihood")
                        : ""
                    }
                    error={Boolean(
                      getIn(touched, "likelihood") &&
                        getIn(errors, "likelihood")
                    )}
                  />
                </Stack>

                <FieldArray name="variants">
                  {({ push, remove }) => (
                    <div>
                      {values?.variants?.map((p, index) => {
                        const length = `variants.[${index}].length`;
                        const touchedLength = getIn(touched, length);
                        const errorLength = getIn(errors, length);

                        const width = `variants.[${index}].width`;
                        const touchedWidth = getIn(touched, width);
                        const errorWidth = getIn(errors, width);

                        const name = `variants.[${index}].name`;
                        const touchedName = getIn(touched, name);
                        const errorName = getIn(errors, name);

                        const capacity = `variants.[${index}].capacity`;
                        const touchedCapacity = getIn(touched, capacity);
                        const errorCapacity = getIn(errors, capacity);

                        const priority = `variants.[${index}].priority`;
                        const touchedPriority = getIn(touched, priority);
                        const errorPriority = getIn(errors, priority);

                        return (
                          <Box key={index}>
                            <Typography
                              variant="h6"
                              fontWeight={"bold"}
                              fontSize={"20px"}
                            >
                              Variant {index + 1}
                            </Typography>
                            <Grid container spacing={2} mb={2}>
                              <Grid item xs={4}>
                                <TextField
                                  variant="outlined"
                                  label="Name"
                                  name={name}
                                  ref={(el) => (fieldRefs.current[name] = el)}
                                  value={p.name}
                                  required
                                  helperText={
                                    touchedName && errorName ? errorName : ""
                                  }
                                  error={Boolean(touchedName && errorName)}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                              </Grid>
                              <Grid item xs={3}>
                                <TextField
                                  variant="outlined"
                                  label="Capacity"
                                  name={capacity}
                                  value={p.capacity}
                                  ref={(el) =>
                                    (fieldRefs.current[capacity] = el)
                                  }
                                  required
                                  helperText={
                                    touchedCapacity && errorCapacity
                                      ? errorCapacity
                                      : ""
                                  }
                                  error={Boolean(
                                    touchedCapacity && errorCapacity
                                  )}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                              </Grid>

                              <Grid item xs={3}>
                                <TextField
                                  variant="outlined"
                                  label="Priority"
                                  name={priority}
                                  value={p.priority}
                                  ref={(el) =>
                                    (fieldRefs.current[priority] = el)
                                  }
                                  required
                                  helperText={
                                    touchedPriority && errorPriority
                                      ? errorPriority
                                      : ""
                                  }
                                  error={Boolean(
                                    touchedPriority && errorPriority
                                  )}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                              </Grid>
                              <Grid item xs={2}>
                                <Button
                                  type="button"
                                  variant="contained"
                                  onClick={() => remove(index)}
                                >
                                  x
                                </Button>
                              </Grid>

                              <Grid item xs={6}>
                                <TextField
                                  variant="outlined"
                                  label="Length"
                                  name={length}
                                  fullWidth
                                  ref={(el) => (fieldRefs.current[length] = el)}
                                  value={p.length}
                                  required
                                  helperText={
                                    touchedLength && errorLength
                                      ? errorLength
                                      : ""
                                  }
                                  error={Boolean(touchedLength && errorLength)}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                              </Grid>

                              <Grid item xs={6}>
                                <TextField
                                  variant="outlined"
                                  label="Width"
                                  fullWidth
                                  ref={(el) => (fieldRefs.current[width] = el)}
                                  name={width}
                                  value={p.width}
                                  required
                                  helperText={
                                    touchedWidth && errorWidth ? errorWidth : ""
                                  }
                                  error={Boolean(touchedWidth && errorWidth)}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        );
                      })}
                      <Button
                        type="button"
                        variant="outlined"
                        onClick={() => {
                          const lastVariant =
                            values?.variants?.[values.variants.length - 1]; 
                          if (lastVariant) {
                            push({
                              ...lastVariant,
                              capacity: Number(lastVariant.capacity) + 1,
                            });
                          } else {
                            push({
                              name: "",
                              capacity: "",
                              priority: 10,
                              length: "",
                              width: "",
                              spacing: {
                                north: "",
                                east: "",
                                west: "",
                                south: "",
                              },
                            });
                          }
                        }}
                      >
                        Add
                      </Button>
                    </div>
                  )}
                </FieldArray>

                {zonesData && (
                  <Stack mt={2}>
                    <Autocomplete
                      onChange={(_, value) =>
                        setValues({ ...values, zoneValue: value })
                      }
                      required
                      name="zoneValue"
                      multiple
                      id="checkboxes-tags-demo"
                      options={zonesData}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option?.partnerDetails?.title ? option.label + " - " + option.partnerDetails?.title : option.label}
                      renderOption={(props, option, { selected }) => (
                        
                        <li {...props} key={option?.id}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option?.partnerDetails?.title ? option.label + " - " + option.partnerDetails?.title : option.label}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="zoneValue"
                          label="Zone"
                          placeholder="Zone"
                          onBlur={handleBlur}
                          ref={(el) => (fieldRefs.current["zoneValue"] = el)}
                          helperText={
                            getIn(touched, "zoneValue") &&
                            getIn(errors, "zoneValue")
                              ? getIn(errors, "zoneValue")
                              : ""
                          }
                          error={Boolean(
                            getIn(touched, "zoneValue") &&
                              getIn(errors, "zoneValue")
                          )}
                        />
                      )}
                    />
                  </Stack>
                )}

                {values?.type === 2 && (
                  <Stack mt={2}>
                    <Autocomplete
                      onChange={(_, value) =>
                        setValues({
                          ...values,
                          items: value.map((item) => ({ ...item, qty: 1 })),
                        })
                      }
                      required
                      ref={(el) => (fieldRefs.current["items"] = el)}
                      name="items"
                      multiple
                      id="checkboxes-tags-demo"
                      options={FetchItems?.items}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option.name}
                      value={values?.items}
                      isOptionEqualToValue={(option, value) => 
                        option?._id === value?._id
                      }
                      renderOption={(props, option, { selected }) => (
                        <li {...props} key={option._id}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.name}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="items"
                          label="Items"
                          placeholder="Select Items"
                          onBlur={handleBlur}
                          helperText={
                            getIn(touched, "items") && getIn(errors, "items")
                              ? getIn(errors, "items")
                              : ""
                          }
                          error={Boolean(
                            getIn(touched, "items") && getIn(errors, "items")
                          )}
                        />
                      )}
                    />
                  </Stack>
                )}

                {values.type == 2 && values.items.length >= 1 && (
                  <Stack
                    justifyContent={"space-between"}
                    flexWrap={"wrap"}
                    flexDirection="column"
                    mt={2}
                  >
                    <Stack
                      flexDirection="row"
                      alignItems="center"
                      justifyContent={"space-between"}
                    >
                      <Typography fontWeight={"bold"}>Name</Typography>
                      <Typography fontWeight={"bold"}>Qty</Typography>
                    </Stack>
                    {values.items.map((item, index) => {
                      return (
                        <Stack
                          key={index}
                          justifyContent={"space-between"}
                          flexWrap={"wrap"}
                          flexDirection="row"
                          alignItems="center"
                          mt={1}
                        >
                          <Box>
                            <img
                              src={`${baseUrl}/g${item.frontViewImage}`}
                              alt={item.name}
                              height="100px"
                            />
                          </Box>
                          <Stack flexDirection={"row"} alignItems={"center"}>
                            <ButtonGroup
                              size="small"
                              aria-label="small outlined button group"
                            >
                              <Button onClick={() => handleDec(item._id)}>
                                -
                              </Button>
                              <Button disabled>{item.qty}</Button>
                              <Button onClick={() => handleInc(item._id)}>
                                +
                              </Button>
                            </ButtonGroup>
                          </Stack>
                        </Stack>
                      );
                    })}
                  </Stack>
                )}

                {connectionPointsOptionsData && (
                  <Box mt={2}>
                    <Typography
                      component="span"
                      fontWeight={"bold"}
                      fontSize={"20px"}
                    >
                      Wall Attachment Points
                    </Typography>
                    <ListItem
                      sx={{ flexDirection: "column", alignItems: "flex-start" }}
                    >
                      {connectionPointsData?.map((item, index) => {
                        return (
                          <Stack
                            key={index}
                            my={1}
                            flexDirection={
                              item.label ===
                              "Center point between Center and East"
                                ? "column"
                                : item.label ===
                                  "Center point between Center and West"
                                ? "column"
                                : "row"
                            }
                            width="100%"
                            alignItems={
                              item.label ===
                              "Center point between Center and East"
                                ? "flex-start"
                                : item.label ===
                                  "Center point between Center and West"
                                ? "flex-start"
                                : "center"
                            }
                          >
                            <ListItemText
                              key={index}
                              primaryTypographyProps={{
                                style: {
                                  fontWeight: "bold",
                                  minWidth: "130px",
                                  marginRight: "10px",
                                },
                              }}
                              primary={item.label}
                            />

                            <Autocomplete
                              fullWidth
                              disablePortal
                              onChange={(_, value) =>
                                setValues({
                                  ...values,
                                  wallAttachments: {
                                    ...values?.wallAttachments,
                                    [item.value]:
                                      ((value || value == "") && value.value) ||
                                      7,
                                  },
                                })
                              }
                              value={connectionPointsData?.find(
                                (item) =>
                                  item.value ==
                                  values?.wallAttachments[item.value]
                              )}
                              name={`circularPoints`}
                              id="combo-box-demo"
                              options={connectionPointsOptionsData}
                              getOptionLabel={(option) => option.label}
                              renderInput={(params) => (
                                <TextField
                                  placeholder={
                                    "Select " + item.label + " Points"
                                  }
                                  name={`wallAttachments`}
                                  {...params}
                                  label={item.label + " Points"}
                                  onBlur={handleBlur}
                                  helperText={
                                    getIn(touched, "wallAttachments") &&
                                    getIn(errors, "wallAttachments")
                                      ? getIn(errors, "wallAttachments")
                                      : ""
                                  }
                                  error={Boolean(
                                    getIn(touched, "wallAttachments") &&
                                      getIn(errors, "wallAttachments")
                                  )}
                                />
                              )}
                            />
                          </Stack>
                        );
                      })}
                    </ListItem>
                  </Box>
                )}


                <Stack mt={2}>
                  <LoadingButton
                    loading={load}
                    variant="contained"
                    fullWidth
                    type="submit"
                    onClick={() => {
                      validateForm().then((errors) => {
                        if (Object.keys(errors).length > 0) {
                          scrollToError(errors);
                        }
                      });
                    }}
                  >
                    Add
                  </LoadingButton>
                </Stack>
              </Form>
            )}
          </Formik>
        </Box>
      </Modal>
    </>
  );
}

const aboutItem = [
  { name: "Single Item", value: 1 },
  { name: "Layout", value: 2 },
];